/**
 * Agent Configuration
 *
 * Shared configuration for AI agents used in the chat system.
 */

import type { AgentType } from '@/types/chat';

export interface AgentUIConfig {
  name: string;
  description: string;
  icon: string;
  color: string;
  endpoint: 'ai-chat' | 'wisr-web-assistant';
}

export const AGENT_CONFIGS: Record<AgentType, AgentUIConfig> = {
  wisr: {
    name: 'Wisr',
    description: 'AI assistant for contacts, partners, and pre-approvals',
    icon: 'Sparkles',
    color: 'purple',
    endpoint: 'wisr-web-assistant'
  },
  encompass_helper: {
    name: 'Encompass Helper',
    description: 'Expert assistant for Encompass LOS',
    icon: 'Building2',
    color: 'blue',
    endpoint: 'ai-chat'
  },
  pre_approval: {
    name: 'Pre-Approval',
    description: 'Pre-approval letter assistance',
    icon: 'FileCheck',
    color: 'emerald',
    endpoint: 'ai-chat'
  },
  document_checklist: {
    name: 'Document Checklist',
    description: 'Required documents helper',
    icon: 'ClipboardList',
    color: 'amber',
    endpoint: 'ai-chat'
  },
  mortgage_education: {
    name: 'Mortgage Education',
    description: 'Learn about mortgages',
    icon: 'GraduationCap',
    color: 'indigo',
    endpoint: 'ai-chat'
  },
  investor_guidelines: {
    name: 'Investor AI',
    description: 'Expert on investor guidelines, credit matrices, and broker agreements',
    icon: 'BookOpen',
    color: 'orange',
    endpoint: 'ai-chat'
  },
  general: {
    name: 'General',
    description: 'General assistance',
    icon: 'MessageCircle',
    color: 'gray',
    endpoint: 'ai-chat'
  }
};

export const DEFAULT_AGENT: AgentType = 'wisr';

export function getAgentConfig(agentType: AgentType): AgentUIConfig {
  return AGENT_CONFIGS[agentType] || AGENT_CONFIGS.general;
}
